function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState } from 'react';
import { withTheme } from '../../core/theming';
import { CheckboxOn, CheckboxOff } from '@suranceadmin/icons/native';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';

const checkboxAccessibilityState = isChecked => {
  const accessbilityState = {
    accessibilityState: {
      checked: isChecked
    }
  };
  return accessbilityState;
};

const Checkbox = _ref => {
  let {
    onValueChange,
    style,
    isChecked = false,
    children,
    theme: {
      colors
    },
    checkboxAccessibility
  } = _ref;
  const [alignItems, setAlignItems] = useState('flex-start');

  const onPress = () => {
    if (onValueChange) {
      onValueChange(!isChecked);
    }
  };

  const renderCheckboxImage = () => {
    if (isChecked) {
      return /*#__PURE__*/React.createElement(CheckboxOn, {
        color: colors.icon.link
      });
    } else {
      return /*#__PURE__*/React.createElement(CheckboxOff, {
        color: colors.icon.link
      });
    }
  };

  const onTextLayout = _ref2 => {
    var _nativeEvent$lines;

    let {
      nativeEvent
    } = _ref2;
    setAlignItems((nativeEvent === null || nativeEvent === void 0 ? void 0 : (_nativeEvent$lines = nativeEvent.lines) === null || _nativeEvent$lines === void 0 ? void 0 : _nativeEvent$lines.length) > 1 ? 'flex-start' : 'center');
  };

  return /*#__PURE__*/React.createElement(View, {
    style: [style, styles.container, {
      alignItems: alignItems
    }]
  }, /*#__PURE__*/React.createElement(TouchableOpacity, _extends({
    accessibilityRole: 'checkbox'
  }, checkboxAccessibility, checkboxAccessibilityState(isChecked), {
    style: styles.checkbox,
    onPress: onPress
  }), renderCheckboxImage()), children && /*#__PURE__*/React.createElement(Text, {
    style: styles.textView,
    onTextLayout: onTextLayout
  }, children));
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row'
  },
  checkbox: {
    paddingHorizontal: 8
  },
  textView: {
    flex: 1,
    marginLeft: 8
  }
});
export default withTheme(Checkbox);
//# sourceMappingURL=index.js.map